import React, { useState, useEffect } from 'react';
import termsOfServiceText from '../assets/terms_of_service.txt';

function TermsOfService() {
  const [termsText, setTermsText] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(termsOfServiceText)
      .then(response => response.text())
      .then(text => {
        setTermsText(text);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading terms of service:', error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="text-lg text-gray-600">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Terms of Service</h1>
          <p className="text-lg text-gray-600">Last updated: Sep 1, 2025</p>
        </div>

        <div className="prose prose-lg max-w-none text-gray-800 leading-relaxed">
          <div className="whitespace-pre-line text-sm">
            {termsText}
          </div>
        </div>

        <div className="mt-12 text-center">
          <a 
            href="/"
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            ← Back to Home
          </a>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;